<div class="wccard p-3 mb-1">
  <app-talent-insights-ai [jobDemandCount]="hasJobDemand" [requestaidata]="skillsdataAI" [insightstabname]="'skills'" [dataPending] = "getDataPendingStatus()"
    [totalcount]="totalResultCount"></app-talent-insights-ai>
</div>

<div class="wccard p-3 mb-3">
  <p class="f-16 font-weight-600 mb-1">
    What is the Skill Taxonomy for This Talent Pool?
  </p>
  <p class="text-484b59 f-10 line-height-1">This chart organizes skills into three levels - Primary, Secondary, and Optional - with categories and individual skills inside each. Use it to explore how talent capabilities are structured and identify core vs. supporting skills for better hiring, training, or planning.</p>
  <div class="text-center position-relative" style="min-height: 300px;">
    <div class="loader d-flex justify-content-center align-items-center flex-column h-100 w-100 position-absolute top-0 start-0" *ngIf="skillTaxonmoyPayload?.length == 0">
      <img *ngIf="skillsTanomoyLoader===true" src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
      <span *ngIf="!skillsTanomoyLoader && !showFilterMessage">No Data Available</span>
      <span *ngIf="showFilterMessage">The current talent pool isn’t sufficient to build a skill taxonomy chart. Consider adjusting your filters.</span>
    </div>
    <div class="col wccard">
      <fusioncharts *ngIf="skillTaxonmoyPayload?.data?.length" width="100%" height="600" type="sunburst"
        dataFormat="json" [dataSource]="skillTaxonmoyPayload">
      </fusioncharts>
    </div>
  </div>
</div>

<div class="wccard p-3 mb-1">

  <p class="f-16 font-weight-600 mb-5">What are the most common skills among this talent?</p>
  <p class="f-12 text-afaf mb-3">Top % Skills</p>
  <div class="d-flex justify-content-between mb-6">
    <div class="d-block" *ngFor="let skill of topFiveSkills; index as i; first as f"
      [ngStyle]="{ 'border-left': f ? null : '1px solid #f2f2f2', 'padding-left': f ? null : '12px' }">
      <div style="min-width: 160px;">
        <p class="f-12 text-afaf mb-1">#{{ i + 1 }}</p>
        <p class="f-14 font-weight-600">{{ skill.key | titlecase }}</p>
      </div>
    </div>
  </div>
  <div>

    <div *ngIf="!skills?.data?.length">
      <div class="loader text-center" *ngIf="!apiCalled">
        <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
      </div>
      <div *ngIf="apiCalled">
        <p class="text-center small p-5 text-484b59">No Data Available</p>
      </div>
    </div>

    <div class="mt-2" *ngIf="skills?.data?.length">
      <table mat-table [dataSource]="skills" class="mat-elevation-z8" style="width: 100%; box-shadow: none;" matSort
        #skillsTbSort="matSort" (matSortChange)="manualSort()">

        <!-- key -->
        <ng-container matColumnDef="key">
          <th mat-header-cell mat-header-cell *matHeaderCellDef class="col-4">
            <p class="text-9696 f-12 m-0"> {{tableHeaderObj['TopSkills']}} </p>
          </th>
          <td class="col-4 text-484b59" mat-cell *matCellDef="let element" style="font-family: 'Poppins', sans-serif;">
            {{element.key | titlecase}}
          </td>
        </ng-container>

        <!-- doc_count -->
        <ng-container matColumnDef="doc_count">
          <th class="text-center col-2" mat-header-cell *matHeaderCellDef mat-sort-header
            sortActionDescription="Sort by doc_count">
            <p class="text-9696 f-12 m-0"> {{tableHeaderObj['TalentCount']}} </p>
          </th>
          <td mat-cell *matCellDef="let element" class="text-484b59 font-weight-600">
            <span class="pointer"
              (click)="handelRedirection('skills', element.key)">{{element.doc_count | number}}</span>
          </td>
        </ng-container>

        <!-- graph -->
        <ng-container matColumnDef="graph">
          <th class="text-center col-2" mat-sort-header sortActionDescription="Sort by percentage" mat-header-cell
            *matHeaderCellDef>
            <p class="text-9696 f-12 m-0 text-left"> {{tableHeaderObj['%Total']}} </p>
          </th>
          <td class="col-2 flex-grow-1" mat-cell *matCellDef="let element">

            <div class="progress d-flex align-items-center" style="height: 12px!important;">
              <span class="mr-1 text-484b59">
                {{getSkillPercentage(element.doc_count)}}%
              </span>
              <span class="progress-bar" role="progressbar" style="background-color: #2E93A1 !important;"
                [ngStyle]="{'width.%': getSkillPercentage(element.doc_count)}"
                aria-valuenow="getSkillPercentage(element.doc_count)" aria-valuemin="0" aria-valuemax="100"></span>
            </div>
          </td>
        </ng-container>
              <ng-container matColumnDef="job_doc_count">
                <th class="col-2"  *matHeaderCellDef mat-header-cell >
                    <p class="text-9696 f-12 m-0" [ngbTooltip]="jobdemand">{{tableHeaderObj['JobDemand']}}</p>
           <ng-template #jobdemand>
                      <p class="f-12 font-weight-600 mb-1">About Job Post Metrics</p>
                      <p class="f-12 mb-1">Job post data is sourced directly from company career pages and official employer sites, ensuring high accuracy and active demand.</p>
                      <p class="f-12">Job post and salary metrics are influenced by Job Titles, Skills, Location, Industry, Company, Seniority, and Function. Changes to other filters (e.g., education, gender, experience) do not impact these values.</p>
                    </ng-template>
                </th>
                <td mat-cell *matCellDef="let element" class="text-484b59 font-weight-600 f-12">
                     <div *ngIf="hasJobDemand" class="spinner-border position-absolute text-black"
                            role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    <span class="" *ngIf="element?.job_doc_count != 0" (click)="hasJobListingAccess &&  openJoblistSlider(element.key)" [class.pointer]="hasJobListingAccess">{{element.job_doc_count | number}}</span>
                    <span class="" *ngIf="!element?.job_doc_count" style="font-family: Arial, sans-serif;">&mdash;</span>

                </td>
            </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>
  <div class="d-flex justify-content-center wccard ng-star-inserted" *ngIf="totalCount > 10">
    <ngb-pagination [collectionSize]="totalCount <=50 ? totalCount : 50" [maxSize]="5" aria-label="Custom pagination" [pageSize]="pageSize"
      rotate="false" (pageChange)="setPage($event)" [(page)]="currentPage" [ellipses]="false" [boundaryLinks]="false"
      [directionLinks]="false">
    </ngb-pagination>
  </div>
</div>
<app-insights-joblist [data]="toOpenSliderFromTabSubject.asObservable()" [events]="sendDataToSliderSubject.asObservable()"></app-insights-joblist>
